import {
  ClockChannelDto,
  GetClockStationParameters_GetClockStationParametersResponse,
  ClockStationService,
  ClockStation_ChannelTimeModel,
  ClockStation_ChannelsStateModel,
  ClockStation_ImpulseModel,
  MechanismsService,
} from "../api";

export const SecondaryClockApi = {

    // Получение параметров
    getParams: async (id: string): Promise<GetClockStationParameters_GetClockStationParametersResponse> => {
        return ClockStationService.getApiClockStationParams(id);
    },

    // Обновление импульса
    updateImpulse: async (id: string, payload: ClockStation_ImpulseModel): Promise<boolean> => {
        await ClockStationService.postApiClockStationChannelsImpulse(id, payload);
        return true;
    },

    // Обновление стейта канала
    updateChannelState: async (id: string, payload: ClockStation_ChannelsStateModel): Promise<boolean> => {
        await ClockStationService.postApiClockStationChannelsState(id, payload);
        return true;
    },

    // Установка положения стрелок в канале
    updateChannelsArrows: async (id: string, payload: ClockStation_ChannelTimeModel): Promise<boolean> => {
        await ClockStationService.postApiClockStationChannelsArrows(id, payload);
        return true;
    },


    // Получение параметров
    getDetails: async (id: string, channel: number): Promise<ClockChannelDto> => {
        return MechanismsService.getApiMechanismsChannel(id, channel);
    },

    // Обновление деталей каналов
    updateChannelsDetails: async (id: string, channel: number, payload: ClockChannelDto): Promise<boolean> => {
        await MechanismsService.putApiMechanismsChannel(id, channel, payload);
        return true;
    },

}
